module.exports = __webpack_public_path__ + "img/pi-4-8.3ea0980d.jpg";